import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import IdentificationType from 'ui/types/identification-type';
import { useTranslateWithStringArgs } from 'ui/hooks/use-translate';
import { snakeToCamelCaseWithNumbers } from 'ui/helper/case-transforms';
import { IdentificationDocumentTypeEnum } from 'src/api';
import * as Styled from './styled';

export interface AddIdentificationDocumentDataProps {
  AddIdentificationForm: any;
  documentValidFrom: Date | undefined;
  documentValidTo: Date | undefined;
  onChangeDocumentType: (documentType: IdentificationDocumentTypeEnum) => void;
}

const AddIdentificationDocumentData: FunctionComponent<AddIdentificationDocumentDataProps> = (props) => {
  const { AddIdentificationForm, documentValidFrom, documentValidTo, onChangeDocumentType } = props;

  const translate = useTranslateWithStringArgs();

  const documentTypes = Object.values(IdentificationType);

  return (
    <>
      <p>
        <strong>
          <Translate name="dashboardIssuerInvestorDetails.addIdentificationForm.subtitleIdentification" />
        </strong>
      </p>
      <AddIdentificationForm.Group name="documentType" required={true}>
        <AddIdentificationForm.Select
          onChange={(documentType: IdentificationDocumentTypeEnum) => onChangeDocumentType(documentType)}
          options={documentTypes.map((documentType) => ({
            value: documentType,
            label: translate(`identificationDocumentType.${snakeToCamelCaseWithNumbers(documentType.toLowerCase())}`),
          }))}
        ></AddIdentificationForm.Select>
      </AddIdentificationForm.Group>
      <AddIdentificationForm.Group name="documentId">
        <AddIdentificationForm.Input />
      </AddIdentificationForm.Group>
      <AddIdentificationForm.Group name="identificationDate" required={true}>
        <AddIdentificationForm.DatePicker maxDate={new Date()} />
        {AddIdentificationForm.Validators.PastDate(
          2,
          true,
          <Translate name="dashboardIssuerInvestorDetails.addIdentificationForm.pastDateError" />,
        )}
      </AddIdentificationForm.Group>
      <p>
        <strong>
          <Translate name="dashboardIssuerInvestorDetails.addIdentificationForm.fields.documentValidity.label" />
        </strong>
      </p>
      <Styled.Row>
        <Styled.Column>
          <AddIdentificationForm.Group name="documentValidFrom">
            <AddIdentificationForm.DatePicker minDate={new Date('1900-01-01')} maxDate={documentValidTo} />
          </AddIdentificationForm.Group>
        </Styled.Column>
        <Styled.Column>
          <AddIdentificationForm.Group name="documentValidTo" required={true}>
            <AddIdentificationForm.DatePicker minDate={documentValidFrom} />
          </AddIdentificationForm.Group>
        </Styled.Column>
      </Styled.Row>
      <AddIdentificationForm.Group name="issuingOffice">
        <AddIdentificationForm.Input />
      </AddIdentificationForm.Group>
    </>
  );
};

export default AddIdentificationDocumentData;
